import { render, staticRenderFns } from "./SendOrderFlb.vue?vue&type=template&id=3d7d50b1&scoped=true"
import script from "./SendOrderFlb.vue?vue&type=script&lang=js"
export * from "./SendOrderFlb.vue?vue&type=script&lang=js"
import style0 from "./SendOrderFlb.vue?vue&type=style&index=0&id=3d7d50b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7d50b1",
  null
  
)

export default component.exports